require('slick-carousel/slick/slick');

/*
 |--------------------------------------------------------------------------
 | Document Ready Function
 |--------------------------------------------------------------------------
 */

$(function () {
    'use strict';

    /**
     * Carousel slick
     * @link http://kenwheeler.github.io/slick
     */
    // Carousel from home: rewards - 4 elements.
    $('.slider-home-rewards').slick({
        lazyLoad: 'ondemand',
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        centerMode: false,
        variableWidth: false,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    arrows: true,
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    arrows: true,
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 640,
                settings: {
                    arrows: true,
                    slidesToShow: 1,
                },
            },
        ],
    });

    // Carousel from home - 4 elements.
    $('.slider-home').slick({
        lazyLoad: 'ondemand',
        slidesToShow: 4,
        slidesToScroll: 1,
        centerMode: false,
        variableWidth: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });

    // Carousel from home - N elements.
    $('.slider-home-site').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        centerMode: false,
        variableWidth: false,
    });

    // Carousel from home before the footer - partners.
    $('.slider-partners').slick({
        autoplay: false,
        slidesToShow: 7,
        rows: 1,
        slidesToScroll: 1,
        arrows: false,
        centerMode: false,
        variableWidth: false,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    autoplay: true,
                    slidesToShow: 5,
                    rows: 1,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    autoplay: true,
                    slidesToShow: 4,
                    rows: 1,
                },
            },
            {
                breakpoint: 640,
                settings: {
                    autoplay: true,
                    slidesToShow: 2,
                    rows: 1,
                },
            },
        ],
    });

    // Carousel from articles - N elements.
    $('.slider-featured').slick({
        lazyLoad: 'ondemand',
        autoplay: true,
        autoplaySpeed: 10000,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        centerMode: false,
        variableWidth: false,
    });

    // Gallery from contest section.
    if ($('.gallery-prize').length) {
        $('.gallery-prize-links img').on('click', (e) => {
            let slider = $(e.currentTarget).attr('data-slide');

            $('.gallery-prize-links img, .gallery-prize-container img').removeClass('active');
            $(e.currentTarget).addClass('active');

            $('.gallery-prize-container img[data-slide=' + slider + ']').addClass('active');
        });
    }

    // Carousel from register with membership card.
    $('.slider-register').slick({
        lazyLoad: 'ondemand',
        autoplay: true,
        autoplaySpeed: 5000,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        centerMode: false,
        variableWidth: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });

    // Carousel from account: services.
    $('.slider-services').slick({
        lazyLoad: 'ondemand',
        slidesToShow: 4,
        arrows: true,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });

    // Carousel from all sections only mobile.
    if ($(document).width() <= 639) {
        $('.carousel-single-mobile').slick({
            lazyLoad: 'ondemand',
            slidesToShow: 1,
            arrows: false,
            slidesToScroll: 1,
            centerMode: false,
            variableWidth: true,
        });
    }

    // Carousel from bonus departments only mobile.
    if ($(document).width() <= 767) {
        $('.carousel-bonus-mobile').slick({
            lazyLoad: 'ondemand',
            slidesToShow: 1,
            arrows: false,
            slidesToScroll: 1,
            infinite: false,
            centerMode: false,
            variableWidth: true,
        });
    }

    // Carousel from about - partners.
    $('.slider-about-partners').slick({
        autoplay: true,
        autoplaySpeed: 0,
        speed: 7000,
        cssEase: 'linear',
        infinite: true,
        slidesToShow: 7,
        rows: 1,
        slidesToScroll: 1,
        arrows: false,
        centerMode: false,
        variableWidth: false,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    autoplay: true,
                    slidesToShow: 5,
                    rows: 1,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    autoplay: true,
                    slidesToShow: 4,
                    rows: 1,
                },
            },
            {
                breakpoint: 640,
                settings: {
                    autoplay: true,
                    slidesToShow: 3,
                    rows: 1,
                },
            },
        ],
    });
});
